import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOnOutClick } from "src/components/hooks";
import api from "src/rest/api";
import { useOverlay } from "src/screens/checkout/OverlayContext";
import { Container } from "./styles";

// import { Container } from './styles';

const UnlinkWarn: React.FC<{
  student: string;
  email: string;
  reload?: () => void;
}> = ({ reload, student, email }) => {
  const cont = useRef<HTMLDivElement>(null);
  const over = useOverlay();

  const [confirmation, setConfirmation] = useState("");

  const nav = useNavigate();

  useOnOutClick(cont, over.dismiss);

  async function ConfirmUnlink() {
    if (email)
      try {
        await api.post("/student/unlink", { ref: student, email });
        over.dismiss();
        reload && reload();
        nav("/dash");
      } catch (err) {
        alert(JSON.stringify(err));
      }
  }

  return (
    <Container ref={cont} className="flex">
      <h2>Aviso!</h2>
      <span style={{ margin: 5 }} />
      <div className="column hfcentered flex">
        <h5>
          Ao desvincular um aluno, você estará excluindo TODOS OS DADOS
          prescritos para este aluno, presentes neste vínculo.
        </h5>
        <span style={{ margin: 5 }} />

        <h5>
          Para confirmar esta ação, escreva o email do aluno no campo abaixo:
        </h5>
      </div>

      <span style={{ margin: 5 }} />
      <div>
        <input
          style={{
            width: 250,
            textAlign: "center",
            boxShadow: "none",
            backgroundColor: "#eee",
          }}
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value.toLowerCase())}
          placeholder={email}
        />
        <button disabled={confirmation !== email} onClick={ConfirmUnlink}>
          Confirmar
        </button>
      </div>
    </Container>
  );
};

export default UnlinkWarn;
